module.exports = __webpack_public_path__ + "images/c4469d7072f54fbc54d19bafd36e4c19-Bahamas.png";